<template>
  <div class="homepage-4">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection/>
      <FeatureSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/heroFour'
import FeatureSection from '../components/FeatureSection/featureFour'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'ThemeFour',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    FeatureSection,
    FooterSection
  }
}
</script>

<style>

</style>